<div class="container col-xxl-8 px-4 py-5 landing-content" >
  <div class="row align-items-center g-5 py-5">

      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">About Us</h1>
      <div class="row align-items-center g-5 py-5">

        <h2 class="display-5 lh-1 mb-3">Overview</h2>
        <p>GeoAstra is a brand owned by Canada GPS. We develop RTK software and RTK GNSS receivers.</p>
        <p>RTK technology has traditionally been complex and expensive, mainly used in the surveying industry. We want to change that.</p>
        <p>Our mission is to bring high-accuracy positioning to more industries, including automotive, robotics, drones, and agriculture. We focus on making RTK technology affordable, easy to use, and accessible to everyone.</p>

        <h2 class="display-5 lh-1 mb-3">Milestones</h2>
        <p>In May 2024, we launched our first NTRIP Caster SaaS platform, GeoAstra NTRIP Caster 1.0, offering a free worldwide NTRIP service.</p>
        <p>By the end of 2025, we released GeoAstra NTRIP Caster 2.0 and the GeoAstra RTK Expert Tool Suite. At the same time, our R&amp;D team developed multiple GNSS receiver models under the GeoAstra brand.</p>
        <p>Today, GeoAstra provides a complete high-accuracy positioning solution, including both software and hardware.</p>

        <h2 class="display-5 lh-1 mb-3">Partnership Opportunities</h2>
        <p>If you are an RTK hardware maker, an RTK product seller, or a company using many RTK devices, we can work together to meet your needs.</p>
        <p>We offer custom solutions such as your own branded NTRIP Caster service or PPK Studio service. You can also partner with us as a hardware OEM manufacturer.</p>

        <h2 class="display-5 lh-1 mb-3">Invest Us</h2>
        <p>The cost of RTK hardware is decreasing rapidly, and RTK technology is ready for wider use. If you are interested in investing and growing this technology with us, please contact <a href="mailto:info@geoastra.com">info&#64;geoastra.com</a>.</p>
        <p>Let’s build the future together.</p>
    </div>


  </div>
</div>

  
